/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvalidSlackEmailsListQueryVariables = {||};
export type InvalidSlackEmailsListQueryResponse = {|
  +invalidSlackEmails: ?$ReadOnlyArray<?string>
|};
export type InvalidSlackEmailsListQuery = {|
  variables: InvalidSlackEmailsListQueryVariables,
  response: InvalidSlackEmailsListQueryResponse,
|};
*/


/*
query InvalidSlackEmailsListQuery {
  invalidSlackEmails
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invalidSlackEmails",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InvalidSlackEmailsListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InvalidSlackEmailsListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "de5e4fde7b76efad35b4179f9a79627e",
    "id": null,
    "metadata": {},
    "name": "InvalidSlackEmailsListQuery",
    "operationKind": "query",
    "text": "query InvalidSlackEmailsListQuery {\n  invalidSlackEmails\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7181e34a05cfd9c5374f2b71b4a6159d';

module.exports = node;
